export default __webpack_public_path__ + "static/media/teacher.21b5e2d9.svg";